'use client';

import {FloatButton, Tooltip} from "antd";
import React from "react";
import {MoonOutlined, SunOutlined} from "@ant-design/icons";

const ThemeSwitcher = (
    {isDarkMode, onThemeToggle}: { isDarkMode: boolean, onThemeToggle: () => void }
) => {

    return (
        <Tooltip title={isDarkMode ? 'Светлая' : 'Тёмная'} placement="left">
            <FloatButton icon={isDarkMode ? <SunOutlined/> : <MoonOutlined/>}
                         onClick={onThemeToggle}
                         style={{zIndex: 9999}}/>
        </Tooltip>

    );
};

export default ThemeSwitcher;